import { render, staticRenderFns } from "./InfoautoCustomerDocuments.vue?vue&type=template&id=00701620&scoped=true"
import script from "./InfoautoCustomerDocuments.vue?vue&type=script&lang=js"
export * from "./InfoautoCustomerDocuments.vue?vue&type=script&lang=js"
import style0 from "./InfoautoCustomerDocuments.vue?vue&type=style&index=0&id=00701620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00701620",
  null
  
)

export default component.exports